"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateStatus = void 0;
var TemplateStatus;
(function (TemplateStatus) {
    TemplateStatus["ACTIVE"] = "ACTIVE";
    TemplateStatus["HIDDEN"] = "HIDDEN";
    TemplateStatus["INACTIVE"] = "INACTIVE";
})(TemplateStatus || (exports.TemplateStatus = TemplateStatus = {}));
//# sourceMappingURL=template.js.map